module.exports = __webpack_public_path__ + "static/CallouttileMob-cc23f9ec3bcfc788617858170f30c97d.png";